import React from 'react'
import { SvgIconProps } from './Home'

const SvgCommunicationsIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="17"
    fill="none"
    viewBox="0 0 21 17"
  >
    <path
      fill={fill ?? "#353535"}
      d="M14.669 8.282H9.057c-.409 0-.817.436-.817.981 0 .545.408.872.817.872h5.51c.51 0 .816-.436.816-.872s-.306-.98-.714-.98z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M20.894 13.622l-1.837-3.596c.612-1.853.408-3.923-.408-5.667-.919-1.853-2.45-3.27-4.388-3.923A6.315 6.315 0 0011.914 0c-1.53 0-3.062.545-4.286 1.417-2.041 0-3.878.762-5.204 2.288C.994 5.122.179 6.975.179 9.045c0 1.308.306 2.615 1.02 3.814L.077 15.692a.737.737 0 000 .654c.102.218.204.436.51.545.102 0 .204.109.306.109.102 0 .204 0 .306-.109l2.755-1.199a7.076 7.076 0 003.572.981 6.856 6.856 0 003.878-1.199h.408c1.633 0 3.367-.654 4.592-1.743l3.367 1.09h.306c.204 0 .409-.11.613-.327.306-.11.408-.545.204-.872zm-17.96-.436c.102-.327.102-.654-.102-.872-.817-1.308-1.123-2.833-.817-4.359.307-1.526 1.123-2.833 2.347-3.705a3.663 3.663 0 011.123-.545C4.669 5.122 4.26 6.756 4.465 8.5c.204 2.07 1.122 3.923 2.653 5.23.51.437 1.02.764 1.53.981-.306.11-.714.11-1.02.11a5.157 5.157 0 01-3.061-.981c-.103-.11-.307-.11-.51-.11-.103 0-.205 0-.307.11l-1.224.545.408-1.2zm14.286-3.27c-.102.219-.102.545.102.764l1.02 1.961-1.836-.654H16.2c-.204 0-.409.11-.612.218-1.021.98-2.45 1.526-3.878 1.526-1.633 0-3.164-.763-4.286-1.962-.919-1.199-1.429-2.724-1.327-4.25.102-1.634.715-3.051 1.94-4.14 1.02-.982 2.448-1.526 3.877-1.526 1.633 0 3.163.762 4.286 1.961 1.326 1.635 1.735 4.032 1.02 6.103z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M14.669 5.994H9.057c-.51 0-.817.436-.817.871 0 .436.408.872.817.872h5.51c.51 0 .816-.436.816-.872 0-.435-.306-.871-.714-.871z"
    ></path>
  </svg>
)


export default SvgCommunicationsIcon